// @ts-nocheck
// needed for standalone app authentication
const initRoutingUtil = () => {
    window.Routing = {
        generate(e) {
            return e === 'jwt_token.rest.get_jwt_token'
                ? `${process.env.BASE_URL.BANK_DOMAIN}/jwt-token/rest/token`
                : e;
        },
    };
};
export default initRoutingUtil;
